import React, { useState, useEffect } from 'react';
import { DocumentSectionSlider } from '@layouts/utils/DocumentSectionSlider';
import { manipulateNodes } from '@helpers/jqueryHelpers';
import { RelatedItemTag } from '@layouts/Related/Related.types';
import './RelatedDocFilter.scss';

interface RelatedDocFilterProps {
  onTagClick: (tag: RelatedItemTag) => void;
  i18n: Record<string, string>;
  tags: RelatedItemTag[];
  isBound: boolean;
}

export const RelatedDocFilter = ({
  onTagClick = () => {},
  i18n,
  tags = [],
  isBound,
}: RelatedDocFilterProps) => {
  const [selectedTag, setSelectedTag] = useState<RelatedItemTag>({ id: 0, name: 'All' });

  useEffect(() => {
    DocumentSectionSlider.init();
  }, []);

  const handleTagClick = (tag: RelatedItemTag) => {
    manipulateNodes('.related-document-block', (node) => node.classList.add('hidden'));
    setSelectedTag(tag);
    onTagClick(tag);
  };

  const renderTag = (tag: RelatedItemTag) => {
    return (
      <li
        key={tag.id}
        onClick={() => handleTagClick(tag)}
        className='c-document-section-list-item swiper-slide'
      >
        <a className={tag.id == selectedTag.id ? 'selected' : ''}>{tag.name}</a>
      </li>
    );
  };

  return tags.length > 0 ? (
    <div className={`c-document-section ${isBound ? 'is-bound' : ''}`}>
      <div className='c-document-section-swiper swiper-container'>
        <ul className='c-document-section-list swiper-wrapper'>
          {renderTag({ id: 0, name: i18n.All })}
          {tags.map(renderTag)}
        </ul>
      </div>
      <div className='c-document-section-button is-next is-hidden' />
      <div className='c-document-section-button is-prev is-hidden' />
    </div>
  ) : null;
};
